/*
  <shintop-pay-marks> — the "+N" button on the payment marks under Add to cart.

  The first four marks and the button are server-rendered; the rest are in the list `hidden`,
  so nothing moves when this arrives. A tap reveals them, removes the button (there is nothing
  left to show) and moves focus to the list, so a keyboard or screen-reader user is not left on
  a control that no longer exists.
*/
if (!customElements.get('shintop-pay-marks')) {
  customElements.define(
    'shintop-pay-marks',
    class ShintopPayMarks extends HTMLElement {
      connectedCallback() {
        this.querySelector('.shintop-pay-marks__more')?.addEventListener('click', (event) => this.reveal(event));
      }

      reveal(event) {
        this.querySelectorAll('[data-pay-extra]').forEach((li) => (li.hidden = false));
        this.querySelector('[data-pay-more]')?.remove();
        // Only a keyboard activation (detail 0) needs focus moved off the removed button; on a tap
        // it drew the house focus ring round the whole row (2026-10-17, first look).
        if (event.detail === 0) this.querySelector('.shintop-pay-marks')?.focus();
      }
    }
  );
}
